import { Skeleton } from '~/@/components/ui/skeleton'
import { LoadingSpinner } from '../ui/atoms/loading-spinner/LoadingSpinner'

export function TableCellLoadingValue() {
  return (
    <div className="flex size-full items-center justify-start gap-2">
      <div className="w-6">
        <LoadingSpinner type="table-cell" />
      </div>
      <div className="flex size-full flex-1 items-center pe-2">
        <Skeleton className="h-4 w-full max-w-32" />
      </div>
    </div>
  )
}
